import axios from 'axios';
import { profitPoolUrls } from 'config/urls';
import pako from 'pako';

const DEBUG_GZIP_REQUESTS = true; // Set to true to enable detailed logging for debugging

export const PROFIT_POOL_API_LIMIT = 20;
export interface SelectedSubFilter {
    dataKey: string;
    dimension: string;
    isAttribute?: boolean;
}

export interface DimIdsFilter {
    dim1: { ids: string[] };
    dim2: { ids: string[] };
    dim3: { ids: string[] };
    dim4: { ids: string[] };
}

export interface TimePeriod {
    start_timestamp: number;
    end_timestamp: number;
}

export interface FetchProfitPoolDataOptions {
    selectedSubFilter?: SelectedSubFilter;
    offset?: number;
    kpi?: string;
    tierList?: string[];
    yearAgo?: boolean;
    groupedByList?: string[];
    dimIdsFilter?: DimIdsFilter;
    frequency?: string;
    timePeriod?: TimePeriod;
    signal?: AbortSignal;
    limit?: number;
    parentDimension?: string;
    parentAttributeType?: string;
}

const fetchProfitPoolData = async (options: FetchProfitPoolDataOptions = {}) => {
    const {
        selectedSubFilter = {
            dataKey: '',
            dimension: '',
            isAttribute: true,
        },
        offset,
        kpi = 'profit_absolute',
        tierList = ['tier1'],
        yearAgo = false,
        groupedByList = [],
        dimIdsFilter = {
            dim1: { ids: [] },
            dim2: { ids: [] },
            dim3: { ids: [] },
            dim4: { ids: [] },
        },
        frequency = 'M',
        timePeriod = {
            start_timestamp: 1646073000,
            end_timestamp: 1753986600,
        },
        signal,
        limit,
        parentDimension,
        parentAttributeType,
    } = options;

    const token = localStorage.getItem('accessToken');
    const requestData = {
        dimension: selectedSubFilter?.dimension,
        attribute_type: selectedSubFilter?.dataKey,
        is_attribute: selectedSubFilter?.isAttribute ?? true,
        grouped_by_list: groupedByList,
        time_period: {
            start_timestamp: timePeriod.start_timestamp,
            end_timestamp: timePeriod.end_timestamp,
        },
        parent_dimension: parentDimension ?? '',
        parent_attribute_type: parentAttributeType ?? '',
        limit: limit,
        offset: offset,
        kpi: kpi,
        tier_list: tierList,
        frequency: frequency,
        year_ago: yearAgo,
        aggregated_period_flag: '',
        filters: dimIdsFilter,
    };

    let jsonString;
    try {
        jsonString = JSON.stringify(requestData);
    } catch (error) {
        if (DEBUG_GZIP_REQUESTS) {
            console.error('Error stringifying requestData:', error);
            console.error('Problematic requestData:', requestData);
        }
        throw error; // Re-throw to propagate the error
    }

    let compressedData;
    try {
        compressedData = new Blob([pako.gzip(jsonString)], { type: 'application/json' });
    } catch (error) {
        if (DEBUG_GZIP_REQUESTS) {
            console.error('Error gzipping JSON string:', error);
            console.error('Problematic JSON string (first 1000 chars):', jsonString?.substring(0, 1000));
        }
        throw error; // Re-throw to propagate the error
    }
    // console.log('requestData', requestData);
    try {
        const response = await axios(`${profitPoolUrls.getProfitPoolDataUrl}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                // 'Accept-Encoding': 'gzip, deflate, br',
                // 'Content-Encoding': 'gzip',
                'Content-Type': 'application/json',
            },
            // data: compressedData,
            data: JSON.parse(jsonString),
            signal: signal,
        });
        return response.data;
    } catch (error) {
        // if (DEBUG_GZIP_REQUESTS) {
        //     console.error('Axios request failed:', error);
        //     console.error('Request data that led to failure:', requestData);
        //     console.error('JSON string:', jsonString?.substring(0, 1000)); // Log first 1000 chars
        // }
        throw error; // Re-throw to propagate the error
    }
};

export default fetchProfitPoolData;
